module.exports = __webpack_public_path__ + "img/tenglong01.10453b95.png";